import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertOrgContractDocumentMutation, InsertOrgContractDocumentMutationVariables } from '@/graphql/generated/graphql';
import { InsertOrgContractDocumentDocument } from '@/graphql/generated/graphql';
export type OrgContractDocumentInsertInput = {
  OrganizationIds?: string[]
  OrganizationId?: string
  GuestSessionId?: string
  Name?: string
  TemplateId?: string
  TemplateSlug?: string
  TemplateTitle?: string
  Status?: string
  IsArchived?: boolean
  IsInTrash?: boolean
  FormData?: string
  EnrichmentContext?: string
  DynamicFields?: string
  CurrentStep?: number
  ProgressPercent?: number
  Document?: string
  Signatories?: string
  SigDocumentUrl?: string
  SigDocumentId?: string
  SigOrgId?: string
  CompletedAt?: string
  HasSentForApproval?: boolean
  IsApproved?: boolean
  Reviewers?: string[]
}

export type InsertOrgContractDocumentResponse = {
  data: {
    insertOrgContractDocument: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertOrgContractDocument = () => {
  const mutation = useMutation({
    mutationKey: ['insert-org-contract-document'],
    mutationFn: (variables: OrgContractDocumentInsertInput) => {
      return graphqlClient.request<InsertOrgContractDocumentMutation>(InsertOrgContractDocumentDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertOrgContractDocument: mutation.mutate,
    insertOrgContractDocumentAsync: mutation.mutateAsync,
  }
}

export const INSERT_ORG_CONTRACT_DOCUMENT_MUTATION = InsertOrgContractDocumentDocument;
